module.exports = function() {
    /* eslint-disable */
    (function() {
        var e = document.createElement('script'); e.async = true;
        e.src = document.location.protocol + '//api.dmcdn.net/all.js';
        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(e, s);
    }());
    /* eslint-enable */
};



// WEBPACK FOOTER //
// ./src/js/external/dailymotion.js